module.exports = __webpack_public_path__ + "static/media/logo.a38bc2f3.svg";